<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Cash Report</h1>

    <!-- Utility Buttons -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
      <div class="d-flex flex-wrap gap-1">
        <button style="background-color: transparent !important; border: none;"
          (click)="onPrint()"
          type="button"
          mat-icon-button
          class="me-1 mb-1"
          matTooltip="Print cash report"
          matTooltipPosition="below"
          aria-label="Print cash report">
          <mat-icon style="color: #1C3F8B;">print</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">


      <div class="row">
        <app-week-year-selector
          [initialWeek]="week"
          [initialYear]="year"
          weekColClass="col-12 col-md-6 col-lg-3"
          yearColClass="col-12 col-md-6 col-lg-3"
          (selectionChange)="onWeekYearChange($event)">
        </app-week-year-selector>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-lg-2">
          <mat-form-field class="full-width-field">
            <mat-label>Instructor</mat-label>
            <mat-select [(ngModel)]="filterInstructorUid" name="filterInstructorUid" (selectionChange)="onFilterChange()">
              <mat-option [value]="null">All</mat-option>
              <mat-option *ngFor="let i of _fieldsService.instructorData()" [value]="i.uid">{{ i.value }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-2">
          <mat-form-field class="full-width-field">
            <mat-label>Payment Type</mat-label>
            <mat-select multiple [(ngModel)]="filterPaymentTypes" name="filterPaymentTypes" (selectionChange)="onFilterChange()">
              <!-- payment_type_all: historical payments can use methods the studio has since hidden -->
              <mat-option *ngFor="let pt of _taxonomyService.payment_type_all" [value]="pt.id">{{ pt.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-2">
          <mat-form-field class="full-width-field">
            <mat-label>Department</mat-label>
            <mat-select multiple [(ngModel)]="filterDepartments" name="filterDepartments" (selectionChange)="onFilterChange()">
              <mat-option *ngFor="let d of departmentData" [value]="+d.key">{{ d.value }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-2">
          <mat-form-field class="full-width-field">
            <mat-label>SPS Code</mat-label>
            <mat-select multiple [(ngModel)]="filterBuckets" name="filterBuckets" (selectionChange)="onFilterChange()">
              <mat-option *ngFor="let b of allBuckets" [value]="b">{{ b }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-2">
          <mat-form-field class="full-width-field">
            <mat-label>Enrollment Type</mat-label>
            <mat-select multiple [(ngModel)]="filterCategories" name="filterCategories" (selectionChange)="onFilterChange()">
              <mat-option *ngFor="let c of _taxonomyService.enrollment_type" [value]="c.id">{{ c.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 col-lg-2">
          <mat-form-field class="full-width-field">
            <mat-label>Payment Status</mat-label>
            <mat-select multiple [(ngModel)]="filterStatuses" name="filterStatuses" (selectionChange)="onFilterChange()">
              <mat-option *ngFor="let s of statusOptions" [value]="s">{{ s }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <section class="section">
          <mat-checkbox [(ngModel)]="includeInactive" name="includeInactive" (change)="onFilterChange()">
            Include inactive instructors
          </mat-checkbox>

          <mat-checkbox [(ngModel)]="includeHistory" name="includeHistory" (change)="onFilterChange()" class="ms-3">
            Include History payments
          </mat-checkbox>

          <div class="float-end bring-inline">
            <button type="button" (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear</button>
          </div>
        </section>
      </div>

    </form>

  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <div class="table-container">

    <!-- <h2>{{ environment.name }} - Week # {{ week }}</h2> -->
    <div class="table-responsive">
      <table class="mt-4 mat-table">
        <thead>
          <tr class="mat-header-row">
            <th class="mat-header-cell">&nbsp;</th>
            <th class="mat-header-cell text-end" *ngFor="let b of activeBuckets">{{ b === 'NONUNIT' ? 'NON UNIT' : (b === 'REFUND' ? 'REFUNDS' : b) }}</th>
            <th class="mat-header-cell text-end">TOTAL</th>
          </tr>
        </thead>

        <tr class="mat-row">
          <td class="mat-cell">(WEEK)</td>
          <td class="mat-cell text-end" *ngFor="let b of activeBuckets">{{ CashReportDataWEEK[b] | studioCurrency }}</td>
          <td class="mat-cell text-end">
            {{ CashReportDataWEEK.PRE + CashReportDataWEEK.ORI + CashReportDataWEEK.EXT +
              CashReportDataWEEK.MISC + CashReportDataWEEK.NONUNIT +
              CashReportDataWEEK.SUNDRY + CashReportDataWEEK.REN - CashReportDataWEEK.REFUND | studioCurrency }}
          </td>
        </tr>

        <tr class="mat-row">
          <td class="mat-cell">(YTD)</td>
          <td class="mat-cell text-end" *ngFor="let b of activeBuckets">{{ CashReportData[b] | studioCurrency }}</td>
          <td class="mat-cell text-end">
            {{ CashReportData.PRE + CashReportData.ORI + CashReportData.EXT +
              CashReportData.MISC + CashReportData.NONUNIT +
              CashReportData.SUNDRY + CashReportData.REN - CashReportData.REFUND | studioCurrency }}
          </td>
        </tr>

      </table>
    </div>

    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortDataView($event)" class="mt-4 d-none">

      <!-- REPLACE Column -->
      <ng-container matColumnDef="nothing">
        <th *matHeaderCellDef sortActionDescription="Sort by nothing">
          nothing
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.nothing }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="row">
      <div class="col-12 col-md-6" *ngFor="let data of convertToArray(this.storage); index as i;">
        <app-cash-report-individual [data]="data">
        </app-cash-report-individual>
      </div>
    </div>

  </div>
</div>
